// extracted by mini-css-extract-plugin
export var header = "_wy-1";
export var maskBottom = "_wy-6";
export var maskMiddle = "_wy-7";
export var maskTop = "_wy-5";
export var root = "_wy-0";
export var scrollDownButton = "_wy-3";
export var scrollDownButtonHidden = "_wy-4";
export var viewport = "_wy-2";